import { render, staticRenderFns } from "./ReporteCostoFormacionHacienda.vue?vue&type=template&id=4cd3242a&"
import script from "./ReporteCostoFormacionHacienda.vue?vue&type=script&lang=ts&"
export * from "./ReporteCostoFormacionHacienda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
